// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__0x1zn","layout":"Layout_layout__6OgGB","footer":"Layout_footer__8CzM0"};